/**
 * Performs a scroll lock
 * Relies on the css class `.no-scroll`
 */
export const lockScroll = () => {
  const scrollbarWidth = (window.innerWidth - document.body.clientWidth);

  document.body.dataset.scroll = window.scrollY;
  document.body.style.setProperty('--scroll-bar-width', `${scrollbarWidth}px`);
  document.body.classList.add('no-scroll');
}

/**
 * Release scroll lock
 * Relies on the css class `.no-scroll`
 */
export const releaseScroll = () => {
  document.body.classList.remove('no-scroll');
  document.body.style.removeProperty(`--scroll-bar-width`);
  if (document.body.hasAttribute('data-scroll')) {
    window.scrollTo(0, document.body.dataset.scroll);
  }
  document.body.removeAttribute('data-scroll');
}
